<template>
  <div id="user_profile">
    <b-row>
      <b-col sm="12">
        <iq-card class="iq-card">
          <div class="iq-card-body profile-page p-0 profilePages">
            <div class="profile-header">
              <div class="cover-container" style="overflow:hidden;">
                <img v-if="vmCoverPic" :src="vmCoverPic" class="rounded img-fluid" style="object-fit: contain; width: 100%;">
                <img v-else :src="vmBannerImage" class="rounded img-fluid" style="object-fit: contain; width: 100%;">
              </div>

              <div class="user-detail text-center mb-3">
                <div class="profile-img" >
                  <img v-if="vmProfilePic" :src="vmProfilePic" alt="profile-img" class="img-fluid rounded-circle orgLogo" />
                  <b-avatar v-else variant="primary" class="avatar-100 rounded" :text="getFirstLetterOfAString(orgObj.org_name)" style="border-radius: 100%!important;"></b-avatar>
                </div>
                <h3 class="p-1">{{orgObj.org_name}}</h3>
                <div class="profile-detail" id="mobileViewDropdpwn">
                  <h3 class="details_flag">
                    {{orgObj.org_city ? orgObj.org_city : '' }}
                    {{orgObj.org_state ? ', ' + orgObj.org_state : '' }}
                    {{orgObj.org_country ? ', ' + orgObj.org_country : '' }}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </iq-card>
        <iq-card class="iq-card">
          <div class="iq-card-body p-0 showFlexListDiv">
            <div class="user-tabing showFlexList">
              <tab-nav :pills="true" id="pills-tab" class="nav nav-pills d-flex align-items-center justify-content-center profile-feed-items p-0 m-0 w-100 ">
                <div  class="flex-fill p-0"  @click="loadTabData(false, 'about')">
                  <tab-nav-items class="flex-fill p-0" :active="aboutActive" id="pills-activity-tab" href="#profile-activity" ariaControls="pills-profile" role="tab" :ariaSelected="aboutActive" title="Profile" />
                </div>
                <div  class="flex-fill p-0" @click="loadTabData(false, 'feed')">
                  <tab-nav-items class="flex-fill p-0" :active="feedActive" id="pills-feed-tab" href="#profile-feed" ariaControls="pills-home" role="tab" :ariaSelected="feedActive" title="events" />
                </div>
                <div  class="flex-fill p-0" @click="loadTabData(false, 'photo')">
                  <tab-nav-items  class="flex-fill p-0" :active="photoActive" id="pills-photo-tab"  href="#photoActive"  ariaControls="pills-photo" role="tab" :ariaSelected="photoActive" title="Photos" />
                </div>
                <div  class="flex-fill p-0" @click="loadTabData(false, 'video')">
                  <tab-nav-items  class="flex-fill p-0" :active="videoActive" id="pills-video-tab"  href="#videoActive"  ariaControls="pills-video" role="tab" :ariaSelected="videoActive" title="Videos" />
                </div>
              </tab-nav>
            </div>
          </div>
        </iq-card>
      </b-col>
      <b-col sm="12">
        <div class="tab-content">
          <tab-content-item :active="feedActive" id="profile-feed" aria-labelled-by="pills-feed-tab">
            <div class="iq-card-body p-0 OrgPublicGideEvent">
              <b-row>
                <b-col lg="12">
                  <GideEventList />
                </b-col>
              </b-row>
            </div>
          </tab-content-item>
          <tab-content-item :active="videoActive" id="profile-activity" aria-labelled-by="pills-activity-tab">
            <div class="iq-card">
              <div class="iq-card-body" v-if="orgObj.org_id && videoActive">
                <Photos :propModuleId="orgObj.org_id" :propModuleType="orgType" :propType="5" :propMediaType="'video'" :propPublicview="true" />
              </div>
            </div>
          </tab-content-item>
          <tab-content-item :active="photoActive" id="profile-activity" aria-labelled-by="pills-activity-tab">
            <div class="iq-card">
              <div class="iq-card-body" v-if="orgObj.org_id && photoActive">
                <Photos :propModuleId="orgObj.org_id" :propModuleType="orgType" :propType="5" :propPublicview="true" />
              </div>
            </div>
          </tab-content-item>
          <tab-content-item :active="aboutActive" id="profile-activity" aria-labelled-by="pills-activity-tab">
            <div class="row">
              <div class="col-12 col-sm-12 col-md-5 col-lg-4 publicContactUs">
                <WebFlowContactUsV2 propPublicContactUs="true"/>
              </div>
              <div class="col-12 col-sm-12 col-md-7 col-lg-8">
                <About :propOrganisationObj="orgObj"/>
              </div>
            </div>
          </tab-content-item>
        </div>
      </b-col>
    </b-row>

    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg">
      </div>
    </b-toast>

    <b-modal v-model="showModelOrganisationDelete" v-if = "showModelOrganisationDelete" size="sm" title="Delete" ok-title="Delete" cancel-title="Cancel">
      <p>
        {{cvDelMessage}}
      </p>
      <template #modal-footer="">
        <b-button size="sm" @click="showModelOrganisationDelete = false">
          {{cvbtnModalCancel}}
        </b-button>
        <b-button size="sm" variant="primary" @click="organisationDelete()">
          {{cvbtnModalDelOk}}
        </b-button>
      </template>
    </b-modal>

    <b-modal
      v-model="showModelMedia"
      scrollable
      size="lg"
      hide-footer no-close-on-backdrop
      modal-class="mediaDialog">
      <MediaView :propMedia="organisationImages" :propIndex="mediaIndex" />
    </b-modal>
  </div>
</template>

<script>
import { socialvue } from "../../../config/pluginInit.js"
import SideBarMenu from "../../../Utils/sidebarMenu.js"
import About from "./About.vue"
import { Images } from "../../../FackApi/api/image.js"
import Utility from "../../../Utils/utility.js"
import addImage from "/src/assets_gide/img/img/addPic.webp"
import { Organisations } from "../../../FackApi/api/organisation.js"
import Photos from "../Photos.vue"
import MediaView from "../MediaView.vue"
import GideEventList from "../../Public/GideEventList.vue"
import WebFlowContactUsV2 from "../../Public/WebFlowContactUsV2.vue"

export default {
  name: "Profile",
  components: {
    Photos,
    MediaView,
    About,
    GideEventList,
    WebFlowContactUsV2
  },
  data () {
    return {
      socialInfo: [
        {
          name: "Posts",
          value: 0
        },
        {
          name: "Follow"
          // value: 0
        },
        {
          name: "Followers",
          value: 0
        }
      ],
      cvOrgId: "",
      cvorganisationEditHeader: "Organisation Edit",
      showModalorganisationEdit: false,
      photos: [],
      profileImages: [],
      orgObj: {},
      orgType: null,
      orgFollowObj: {},
      vmProfilePic: "",
      vmCoverPic: "",
      vmFollowData: Object.assign({}, this.initFollowData()),
      orgAccess: {
        "organisation_edit": false
      },
      cvbtnModalDelOk: "Delete",
      cvDelMessage: "Are You Sure?",
      cvDisapproveMessage: "Are you Sure you want to unApprove ?",
      cvbtnModalCancel: "Cancel",
      cvbtnUnapprove: "Disapprove",
      containsUserDataModules: false,
      followStatusOfCurrUser: 0,
      followerApiFire: false,
      feedActive: false,
      aboutActive: true, // Show on Page Load
      photoActive: false,
      videoActive: false,
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "Organisation Response",
      propModuleName: "ORG",
      vmBannerImage: "",
      delObj: {},
      showModelOrganisationDelete: false,
      showModelOrganisationUnapprove: false,
      organisationImages: [],
      organisationVideos: [],
      cvImageReading: false,
      vmImageData: Object.assign({}, this.initImageData()),
      vmImagePreview: [],
      cvVideoAddTitle: "Add Video",
      showModelVideo: false,
      vmVideoLink: null,
      allVideoLinks: [],
      cvVideoUrlMsg: "Only youtube url is supported",
      cvVideoUrlValidMsg: "Currently only youtube links are supported",
      showModelMedia: false,
      mediaIndex: 0,
      addImage: addImage,
      admissionOpenModal: false,
      admissonObj: {},
      sideBarItemsList: SideBarMenu.getSideBarMenuObjList(),
      orgTypeFull: "Organisation",
      isMobileDevice: window.__IS__MOBILE_DEVICE__,
      vmEventlist: [],
      isPublic: true
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  beforeMount () {
    this.cvOrgType = this.$route.params.org_type
    this.cvOrgId = this.$route.params.org_id

    switch (this.cvOrgType) {
      case "SCH":
        this.orgTypeFull = "School"
        break
      case "UNIV":
        this.orgTypeFull = "University"
        break
      case "ORG":
      default:
        this.orgTypeFull = "Organisation"
        break
    }
  },
  mounted () {
    socialvue.index()
    this.loadRequiredData()
  },
  methods: {
    /**
     * goToOrgDomainValidate
     */
    goToOrgDomainValidate () {
      this.$router.push(`/org_domain_validate/${this.cvOrgType}/${this.cvOrgId}`)
    },
    /**
     * enrollAdmission
     */
    async enrollAdmission () {
      this.$router.push(`/admission/add/${this.orgObj.org_id}`)
    },
    /**
     * gotoCurrentEvent
     */
    gotoCurrentEvent () {
      let url = `/public/GideViewCurrentEvent/${this.orgObj.org_id}`
      window.open(url, "_blank")
    },
    /**
     * My Student Events
     */
    goToMyStudentAdmissions () {
      this.$router.push("/admissionAnalyticsSchoolWise")
    },
    /**
     * closeAdmissionModal
    */
    closeAdmissionModal (event) {
      this.admissionOpenModal = false
      if (event && event.resp_status) {
        this.admissonObj = event.resp_data
      }
    },
    /**
     * emitOpenAboutTab
     */
    emitOpenAboutTab () {
      this.loadTabData(false, "about")
    },
    /**
     * initImageData
    */
    initImageData () {
      return {
        module_id: "",
        module_name: this.orgType,
        image: [],
        image_type: {}
      }
    },
    /**
     * addVideoLink
     */
    addVideoLink () {
      if (this.vmVideoLink) {
        let youtubeUrlRegex = /^(http(s)?:\/\/)?((w){3}.)?youtu(be|.be)?(\.com)?\/.+/gm
        let videoIdRegex = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/
        let obj = {
          video: this.vmVideoLink,
          embeded: ""
        }
        // check url is whether youtube url or not
        let validUrl = youtubeUrlRegex.test(this.vmVideoLink)
        if (!validUrl) {
          this.showToast = true
          this.toastMsg = this.cvVideoUrlMsg
          this.vmVideoLink = ""
          return false
        }
        let videoIdFound = this.vmVideoLink.match(videoIdRegex)
        if (!videoIdFound) {
          this.vmVideoLink = ""
          this.cvVideoError = true
          this.toastMsg = this.cvVideoUrlValidMsg
          return false
        }
        else {
          this.cvVideoError = false
          this.toastMsg = ""
          let videoId = videoIdFound[1]
          obj.embeded = `https://www.youtube.com/embed/${videoId}`
        }
        this.allVideoLinks.push(obj)
        this.vmVideoLink = null
        return true
      }
    },
    /**
     * initFollowData
     */
    initFollowData () {
      return {
        module_id: "",
        module_name: "",
        follow_status: 0
      }
    },
    /**
    * addPost
    */
    addPost (post) {
      this.socialPosts.unshift(post)
    },
    /**
     * getFirstLetterOfAString
     */
    getFirstLetterOfAString (string) {
      if (string) {
        return string.substr(0, 1)
      }
    },
    /**
     * loadRequiredData
     */
    loadRequiredData () {
      this.orgType = this.$route.params.org_type
      this.cvOrgId = this.$route.params.org_id
      this.organisationView()
      this.setUserRoles()
      this.imageGetProfileImages()
    },
    /**
     * getUserRoles
     */
    setUserRoles () {
      let orgId = this.$route.params.org_id
      if (this.userData && this.userData.roles && this.userData.roles[orgId] && this.userData.roles[orgId]["actions"]) {
        if (this.userData.roles[orgId].udr_name && (this.userData.roles[orgId].udr_name.toLowerCase() === "admin" || this.userData.roles[orgId].udr_name.toLowerCase() === "owner")) {
          this.orgAccess.organisation_edit = true
          return
        }

        let actions = this.userData.roles[orgId]["actions"]
        let orgEditAccess = actions.findIndex(obj => {
          return obj.api_name.toLowerCase() === "organisation_edit"
        })

        if (orgEditAccess > -1) {
          this.orgAccess.organisation_edit = true
        }
      }
    },
    /**
     * organisationList
     */
    async organisationView () {
      try {
        let orgViewResp = await Organisations.organisationViewPublic(this, this.cvOrgId)
        if (orgViewResp && orgViewResp.resp_status) {
          this.orgObj = orgViewResp.resp_data.data

          this.organisationImages = orgViewResp.photos
          this.organisationVideos = orgViewResp.videos
          this.admissonObj = orgViewResp.admisson

          this.vmBannerImage = Utility.getBgImageForLetter(this, this.orgObj.org_name)

          if (orgViewResp.post_count) {
            this.socialInfo[0]["value"] = orgViewResp.post_count
          }

          if (orgViewResp.organisation_follow && orgViewResp.organisation_follow.follow_count) {
            this.socialInfo[2].value = orgViewResp.organisation_follow.follow_count
          }
        }
      }
      catch (err) {
        console.error("Exception occurred at organisationView() and Exception:", err.message)
      }
    },
    /**
     * imageGetProfileImages()
     */
    async imageGetProfileImages () {
      try {
        let imageProfileResp = await Images.imageListProfileImages(this, this.cvOrgId, this.isPublic)
        if (imageProfileResp && !imageProfileResp.resp_status) {
          return false
        }
        else {
          this.vmProfilePic = imageProfileResp.resp_data.profile_pic ? imageProfileResp.resp_data.profile_pic.image_thumbnail : ""
          this.vmCoverPic = imageProfileResp.resp_data.cover_pic ? imageProfileResp.resp_data.cover_pic.image : ""
        }
      }
      catch (err) {
        console.error("Exception occurred at imageGetProfileImages() and Exception:", err.message)
      }
    },
    /**
     * loadFolloweData
     */
    loadTabData (bool, tabType) {
      try {
        this.followerApiFire = bool
        this.feedActive = false
        this.aboutActive = false
        this.photoActive = false
        this.videoActive = false

        if (tabType === "feed") {
          this.feedActive = true
        }
        else if (tabType === "about") {
          this.aboutActive = true
        }
        else if (tabType === "photo") {
          this.photoActive = true
        }
        else {
          this.videoActive = true
        }
      }
      catch (err) {
        console.error("Exception occured at loadTabData() and Exception", err.message)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@media only screen and (max-width:700px) {
  ul.header-nav {
    bottom: 90px !important;
  }
}
.pointer{
  cursor: pointer;
}
.details_flag{
  margin: auto !important;
  position: relative;
  padding: 0px 40px;
  width: auto;;
  white-space: normal;
}
.profileMoreBtn{
  display: flex;
  float: right;
}
#user_profile .profile-header .user-detail {
    position: relative;
    bottom: 30px;
    margin-top: -40px;
    height: auto;
}
@media (max-width: 767px){
  .user-detail{
    .profile-img{
      .header-nav{
        display: none !important;
      }
    }
  }
}
.menu_icon{
  position: absolute;
  right: 10px;
  top: -45px;
  #dropdownMenuButton40__BV_toggle_{
    a{
      display: block;
      width: 20px;
    }
  }
}
.orgLogo {
  object-fit: contain;
  width: 100px;
  height: 100px !important;
  background: white;
}
.uploadImagesInput {
  position: absolute;
  width: 100%;
  margin-left: -90px;
  opacity: 0;
}
ul.profile-img-gallary {
  li {
    height: 100px;
    width: 100%;
    padding: 6px 3px !important;
    img {
      object-fit: cover;
      height: 100%;
      width: 100%;
    }
  }
}
.profile-video-gallary {
  li {
    width: 100%;
    padding: 6px 3px !important;
  }
}
.previewImages {
  img {
    background-attachment: fixed;
    opacity: 0.5;
    &:before{
      content: "Joe's Task: ";
    }
  }
}
.videoLinkList {
  li {
    overflow: hidden;
    word-break: break-all;
    .closeIcon {
      position: relative;
    }
  }
}
.user-images {
  height: 234px;
}
.videoList {
  // height: 150px;
  img, iframe {
    width: 100%;
    height: 230px;
    object-fit: cover;
  }
}
.today_btn{
  position: relative;
  top: -4px;
}
#user_list{
  padding: 0px;
}
.profile-detail{
  position: relative;
}
</style>
